module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionAglz.1f5fb45d.png";